module.exports = __webpack_public_path__ + "img/23_53.4ce81e35.png";